module.exports = __webpack_public_path__ + "png/add-photos.png?8a906837535a562432086c49cd9f7b9f";